import { VBC_API_GATEWAY } from '@/api/index';

export const getExtensionAppsConfig = async (extensionId) => {
  const response = await VBC_API_GATEWAY.get(`/app-center/extensions/${extensionId}/app-config`, {
    params: { platform: 'shellClient', version: process.env.VUE_APP_VERSION },
  });
  return response.data;
};
